import { render, staticRenderFns } from "./SetupModel.vue?vue&type=template&id=56327bca&"
import script from "./SetupModel.vue?vue&type=script&lang=js&"
export * from "./SetupModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports